// central gas
const british_standard_terminal_units = require("../../assets/images/accessories/central-gas/british-standard-terminal-units.png");
const critical_area_bed_head_units = require("../../assets/images/accessories/central-gas/critical-area-bed-head-units.png");
const patient_bed_head_units = require("../../assets/images/accessories/central-gas/Patient-Bed-Head-Units.png");
const ags_plant = require("../../assets/images/accessories/central-gas/ags_plant.webp");
const medical_air_plant1 = require("../../assets/images/accessories/central-gas/medical_air_plant1.webp");
const medical_air_plant2 = require("../../assets/images/accessories/central-gas/medical_air_plant2.webp");
const medical_vaccum_plant = require("../../assets/images/accessories/central-gas/medical_vaccum_plant.webp");
const oxygen_cylinder_manifolds = require("../../assets/images/accessories/central-gas/oxygen_cylinder_manifolds.webp");
const avsu = require("../../assets/images/accessories/central-gas/avsu.webp");
const avsu2 = require("../../assets/images/accessories/central-gas/avsu2.webp");

export const centralGasesData = [
  {
    type: "Central Gases",
    instruments: [
      {
        image: british_standard_terminal_units,
        title: "British Standard Terminal Units",
        heading: "",
        working:
          "The terminal units are mechanical devices that form the end-point of the gas supply line in hospitals, clinics and vehicles. These units are medical gas supply points that provide a convenient and safe delivery of gas at the point where it is needed.",
        description: [
          "The terminal units are mechanical devices that form the end-point of the gas supply line in hospitals, clinics and vehicles. These units are medical gas supply points that provide a convenient and safe delivery of gas at the point where it is needed.",
          "Owing to the obvious danger of wrong connections where multiple gas outlets are installed at the same point, these units ensure fool-proof, mechanical, non-interchangeable gas connections.",
        ],
        characteristics: [
          "Designed to allow main body to be installed during construction, and final assembly after completion of all civil and MEP works.",
          "Marked and Indexed connection between main body and final assembly.",
          "Gas-specific full-color final assembly to help identify units.",
          "Available in a range of mounting arrangements –surface, flush, bedhead, pendant, ambulance etc.",
          "Possible to have NIST inlet connections also.",
          "100% inspection before delivery.",
        ],
      },
      {
        image: critical_area_bed_head_units,
        title: "Critical Area Bed Head Units",
        heading: "",
        working:
          "Bed Head Units provide a common, integrated point-of-use platform for many services required by the patients including, but not limited to",
        description: {
          describe:
            "Bed Head Units provide a common, integrated point-of-use platform for many services required by the patients including, but not limited to:",
          list1: [
            "Medical Gases",
            "Communications",
            "Nurse call system",
            "Lighting",
            "Data and monitoring",
            "Audio Video Controls,",
          ],
        },
        characteristics: [
          "300+ mm height",
          "Two tiered unit to provide large number of gas and electric components w/o increasing length",
          "Ideal for Recovery Rooms and ICUs",
        ],
      },
      {
        image: patient_bed_head_units,
        title: "Patient Bed Head Units",
        heading: "",
        working:
          "Bed Head Units allow the utilities like gas, electricity, lighting and data to be around the patient bed, not only as per standard medical practices, but also in an aesthetic and cluster free manner.",
        description: {
          describe: "",
          list1: [
            "BHUs bring functionality and ease close to the patient in a wide variety of options. Whether in wards, rooms, or critical care areas.",
            "Aesthetically, our system is very flexible in order to suit the architects’ requirements.",
            "Please contact us for all the available sizes and options.",
            "Herzmann offers consultancy and design services for such systems.",
          ],
        },
        characteristics: [
          "220 mm height",
          "Single tier unit incorporating gas and electric components, with room and reading lights",
          "Ideal for Wards and Patient Rooms",
        ],
      },
      {
        image: avsu,
        image2: avsu2,
        title: "AVSU",
        heading: "",
        working:
          "Area Valve Service Units help divide the hospital into different zones.",
        description: {
          describe: "",
          list1: [
            "This enables zone-wise maintenance and zone-wise response in emergency situations.",
            "Also, a complete alarm system is incorporated which makes clear visual and audible alerts in case any of the alarm criteria is met.",
            "Optionally these units can be connected to the Herzmann portal enabling the user to be aware of the system status remotely.",
          ],
        },
        characteristics: [],
      },
      {
        image: medical_air_plant2,
        image2: medical_air_plant1,
        title: "Medical Air Plant",
        heading: "Compressed Medical Air Plant with Supply Center.",
        working:
          "Set formed by primary, secondary and / or backup for Medical Air and Surgical Air, interconnected in a specific way, in order to allow continuous supply to the distribution network.         ",
        description: {
          describe: "",
          list1: [
            "Within the supply center, the compressed air is stored, de-humidified, filtered in various steps and distributed at various pressures. Composed of pressure regulating valves, gauges, filters, manoeuvring valves, lock and security.",
            "Plant status can be monitored at all times on the plant or via the optional portal.",
            "Please contact us for all the available sizes and options.",
            "Herzmann offers consultancy and design services for such systems.",
          ],
        },
        characteristics: [],
      },
      {
        image: medical_vaccum_plant,
        title: "Medical Vacuum Plant",
        heading: "Vacuum Plant.",
        working:
          "Set formed by primary, secondary and / or backup for Medical Vacuum, interconnected in a specific way, in order to allow continuous supply to the distribution network.",
        description: {
          describe: "",
          list1: [
            "Plant protection systems are in place in-line which enable a smooth and carefree operation.",
            "Plant status can be monitored at all times on the plant or via the optional portal. ",
            "Please contact us for all the available sizes and options. ",
            "Herzmann offers consultancy and design services for such systems. ",
          ],
        },
        characteristics: [],
      },
      {
        image: oxygen_cylinder_manifolds,
        title: "Oxygen Cylinder Manifolds",
        heading: "",
        working:
          "The Oxygen Gas Manifold is important in the management of Oxygen in healthcare facilities. It ensures the supply of medical gases and controls the pressure and flow of the system, due to its automatic switching and alerting the user to change cylinders. ",
        description: {
          describe: "",
          list1: [
            "Primary, Secondary and emergency sources are configurable as per hospital size and capacity.",
            "They include flexible hoses to withstand the output pressure of the cylinders. Optionally made out of stainless steel, for reduced wear and tear and longer inspection and maintenance intervals. ",
            "Please contact us for all the available sizes and options.",
            "Herzmann offers consultancy and design services for such systems.",
          ],
        },
        characteristics: [],
      },
      {
        image: oxygen_cylinder_manifolds,
        title: "Nitrous Oxide Cylinder Manifolds",
        heading: "",
        working:
          "The Nitrous Oxide Gas Manifold is important in the management of Nitrous Oxide in hospitals. It ensures the supply of medical gases and controls the pressure and flow of the system, due to its automatic switching and alerting the user to change cylinders.       ",
        description: {
          describe: "",
          list1: [
            "Primary, Secondary and emergency sources are configurable as per hospital size and capacity.",
            "They include flexible hoses to withstand the output pressure of the cylinders. Optionally made out of stainless steel, for reduced wear and tear and longer inspection and maintenance intervals. ",
            "Please contact us for all the available sizes and options.         ",
            "Herzmann offers consultancy and design services for such systems.",
          ],
        },
        characteristics: [],
      },
      {
        image: ags_plant,
        title: "AGSS Plant",
        heading: "",
        working:
          "The Anesthesia Gas Scavenging is a logic based plant, with primary and backup functions, which enable removal of harmful exhaled anesthesia gases, from the breathing circuit.",
        description: {
          describe: "",
          list1: [
            "Please contact us for all the available sizes and options.",
            "Herzmann offers consultancy and design services for such systems.",
          ],
        },
        characteristics: [],
      },
    ],
  },
];
